import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { getId, usePermissions } from "../../user/User"
import ClientDetailView from "./ClientDetailView"

const ClientCreate = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to create clients!")
            navigate("/")
        }
    }, [permissions])
    
    const [companyName, setCompanyName] = useState("")
    const [sector, setSector] = useState(0)
    const [salesPerson, setSalesPerson] = useState(0)
    const [status, setStatus] = useState('New')
    const [statusUpdated, setStatusUpdated] = useState(new Date())
    const [initialPrice, setInitialPrice] = useState(0.0)
    const [monthlyPrice, setMonthlyPrice] = useState(0.0)
    const [initialPaymentDate, setInitialPaymentDate] = useState(new Date())
    const [serviceAgreementStart, setServiceAgreementStart] = useState(new Date())
    const [serviceAgreementEnd, setServiceAgreementEnd] = useState(new Date())
    const [builtWebsite, setBuiltWebsite] = useState(false)
    const [tags, setTags] = useState([])
    const [contactPersonName, setContactPersonName] = useState("")
    const [emailAddress, setEmailAddress] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [notes, setNotes] = useState("")
    const [tasks, setTasks] = useState([])

    return <ClientDetailView id={null}
        companyName={companyName} setCompanyName={setCompanyName}
        sector={sector} setSector={setSector}
        salesPerson={salesPerson} setSalesPerson={setSalesPerson}
        status={status} setStatus={setStatus}
        statusUpdated={statusUpdated} setStatusUpdated={setStatusUpdated}
        initialPrice={initialPrice} setInitialPrice={setInitialPrice}
        monthlyPrice={monthlyPrice} setMonthlyPrice={setMonthlyPrice}
        initialPaymentDate={initialPaymentDate} setInitialPaymentDate={setInitialPaymentDate}
        serviceAgreementStart={serviceAgreementStart} setServiceAgreementStart={setServiceAgreementStart}
        serviceAgreementEnd={serviceAgreementEnd} setServiceAgreementEnd={setServiceAgreementEnd}
        builtWebsite={builtWebsite} setBuiltWebsite={setBuiltWebsite}
        tags={tags} setTags={setTags}
        contactPersonName={contactPersonName} setContactPersonName={setContactPersonName}
        emailAddress={emailAddress} setEmailAddress={setEmailAddress}
        phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
        notes={notes} setNotes={setNotes}
        tasks={tasks} setTasks={setTasks}
    />
}
   
export default ClientCreate
